<div class="modal-backdrop" *ngIf="selectedPreviewUrl || xmlContent">
  <div class="modal-content p-3" style="width: 100%;height: 600px; display: flex; flex-direction: column;">

    <!-- Vista previa para PDF -->

    <iframe *ngIf="fileType === 'pdf'" [src]="selectedPreviewUrl" type="application/pdf" width="700"
      height="500"></iframe>

    <!-- Vista previa para XML corregida -->
    <textarea *ngIf="fileType === 'xml'" readonly class="form-control bg-dark text-light font-monospace"
      style="width: 700px; height: 480px; resize: none; font-size: 12px;" [value]="xmlContent"></textarea>

    <!-- Botón de cerrar -->
    <div class="d-flex w-100 justify-content-center align-items-center mt-3">
      <button class="btn btn-danger px-4" (click)="closePreview()">Cerrar</button>
    </div>

  </div>
</div>